import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Target } from "lucide-react";
import { db, aggregate } from "@/lib/storage";
import { formatIDR, formatIDRShort } from "@/lib/format";

/** Progress bar target harian / bulanan. Sembunyi kalau target = 0. */
export function TargetProgress({ range }: { range: "today" | "month" }) {
  const { data: prefs } = useQuery({ queryKey: ["prefs"], queryFn: () => db.getPrefs() });
  const { data: notes = [] } = useQuery({ queryKey: ["notes"], queryFn: () => db.getNotes() });
  const target = range === "today" ? prefs?.targetDaily ?? 0 : prefs?.targetMonthly ?? 0;
  const stats = useMemo(() => aggregate(notes, range), [notes, range]);

  if (!target) return null;
  const pct = Math.min(100, Math.round((stats.omset / target) * 100));
  const done = pct >= 100;
  const remaining = Math.max(0, target - stats.omset);
  const hide = !!prefs?.hideAmounts;

  return (
    <div className="rounded-2xl border border-border bg-card shadow-soft p-3">
      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center gap-1.5 text-muted-foreground">
          <Target className="h-4 w-4" />
          <span>Target {range === "today" ? "hari ini" : "bulan ini"}</span>
        </div>
        <span className={"tabular-nums font-medium " + (done ? "text-emerald-600 dark:text-emerald-400" : "")}>
          {pct}%
        </span>
      </div>
      <div className="mt-2 h-2 rounded-full bg-muted overflow-hidden">
        <div
          className={"h-full rounded-full transition-all " + (done ? "bg-emerald-500" : "bg-primary")}
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-1.5 text-xs text-muted-foreground tabular-nums">
        {hide
          ? "•••"
          : done
            ? `Target tercapai · ${formatIDR(stats.omset)}`
            : `${formatIDRShort(stats.omset)} dari ${formatIDRShort(target)} · sisa ${formatIDRShort(remaining)}`}
      </div>
    </div>
  );
}
